export const envEnum = {
    dev: 'dev',
    staging: 'staging',
    prod: 'prod',
} as const;

export type envEnum = (typeof envEnum)[keyof typeof envEnum];
